import React, { CSSProperties } from 'react'

import { IconStyles } from '../types'
import { LoadingCustom } from './LoadingIcon.styles'
import { COLORS, FONTS } from 'utils'

interface ILoadingIcon extends IconStyles {
  progress?: number
  message?: string
}

const LoadingIcon: React.FC<ILoadingIcon> = ({
  colorIcon,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  height,
  width,
  progress,
  message // Nova propriedade opcional para a mensagem.
}) => {
  const styles: { [key: string]: CSSProperties } = {
    messageContainer: {
      position: 'absolute' as const,
      top: '60%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      padding: '10px 20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
    },
    messageText: {
      color: COLORS.blueFonts,
      fontSize: '1rem',
      fontWeight: 'bold',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0)'
    }
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <LoadingCustom
        value={progress}
        variant={progress ? 'determinate' : 'indeterminate'}
        marginTop={marginTop}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        marginRight={marginRight}
        cursor={cursor}
        colorIcon={colorIcon}
        width={width}
        height={height}
      />
      {message && (
        <div style={styles.messageContainer}>
          <p style={styles.messageText}>{message}</p>
        </div>
      )}{' '}
      {/* Renderiza a mensagem condicionalmente */}
    </div>
  )
}

export default LoadingIcon
